import React, { useEffect, useState, useContext } from "react";
import Tile from "../components/Tile";
import "../App.css";
import { useNavigate } from "react-router-dom";
import { SzakokContext } from "../context/SzakokContext";
import { UserContext } from "../context/UserContext"; 
import SzakokFinder from "../apis/SzakokFinder";
import { v4 as uuidv4 } from "uuid";
// import "./SzakjelentesLetrehozas.css"; 
import "../components/szakjelentesCreate/SzakjelentesCreate.css"; 

const getLocalDateTime = () => {
    const date = new Date();
    return date.toLocaleString("sv-SE", {
        hour12: false,
        timeZone: "Europe/Budapest"
    }).replace(" ", "T").slice(0, 16);
};

const unlimitedCreatorCodes = ['TLXEEE', 'AEC7DM', 'FWDOMU', 'HPKR9W'];

const canCreateMultipleReports = (userNeptun, szakfelelosNeptun) =>
    unlimitedCreatorCodes.includes(userNeptun) && userNeptun === szakfelelosNeptun;

function SzakjelentesLetrehozas() {
    const { szakfelelosok, setSzakfelelosok, setSelectedSzakfelelos, setSzakok } = useContext(SzakokContext);
    const { userData } = useContext(UserContext);  
    const [filteredData, setFilteredData] = useState([]);
    const [activePeriod, setActivePeriod] = useState(null);
    const [loading, setLoading] = useState(true);
    const [creatingSzakKod, setCreatingSzakKod] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        let mounted = true;

        const fetchCreationOptions = async () => {
            try {
                const [periodResponse, szakfelelosokResponse] = await Promise.all([
                    SzakokFinder.get('/api/periods/active').catch(err => {
                        if (err.response?.status === 404) return null;
                        throw err;
                    }),
                    SzakokFinder.get('/szakfelelosok')
                ]);
                if (mounted) {
                    setActivePeriod(periodResponse?.data?.data?.name || null);
                    setSzakfelelosok(szakfelelosokResponse.data?.data?.szakfelelosok || []);
                }
            } catch (err) {
                if (mounted) setErrorMessage('Nem sikerült betölteni a létrehozáshoz szükséges adatokat.');
                console.error('Hiba a létrehozási adatok lekérésekor:', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchCreationOptions();
        return () => { mounted = false; };
    }, [setSzakfelelosok]);

    useEffect(() => {
        if (userData && userData.name) {
            const filtered = szakfelelosok.filter((item) => item.szakfelelos_neve?.toLowerCase() === userData.name.toLowerCase());
            setFilteredData(filtered);
        }
    }, [userData, szakfelelosok]);

    const handleTileClick = async (szakfelelos) => {
        const canCreateAgain = canCreateMultipleReports(userData?.neptun, szakfelelos.szakfelelos_neptun_kodja);
        if (!activePeriod || loading || creatingSzakKod || (szakfelelos.szakjelentes_created_this_period && !canCreateAgain)) return;

        setCreatingSzakKod(szakfelelos.szak_kod);
        setErrorMessage('');
        const newSzakId = uuidv4();

        const newSzakData = {
            szak_id: newSzakId,
            name: szakfelelos.kepzes_neve,
            szak_kod: szakfelelos.szak_kod,
            szakfelelos_nev: szakfelelos.szakfelelos_neve,
            modosito_neve: userData.name,
            felev: activePeriod,
            status: 1,
            modositas_datuma: getLocalDateTime(),
        };

        try {
            const freshSzakfelelos = await SzakokFinder.get(`/szakfelelosok/szakkod/${encodeURIComponent(szakfelelos.szak_kod)}`);
            if (freshSzakfelelos.data?.data?.szakjelentes_created_this_period && !canCreateAgain) {
                setSzakfelelosok(prev => prev.map(item =>
                    item.szak_kod === szakfelelos.szak_kod ? { ...item, szakjelentes_created_this_period: true } : item
                ));
                setErrorMessage('Már készült szakjelentés ehhez a szakhoz az aktív periódusban.');
                return;
            }

            const response = await SzakokFinder.post("/szakok", newSzakData);
            setSzakok((prevSzakok) => [...prevSzakok, response.data]);
            setSelectedSzakfelelos(szakfelelos);
            navigate(`/szakjelentesek/${newSzakId}/alapadatok`);
        } catch (err) {
            if (err.response?.status === 409) {
                setSzakfelelosok(prev => prev.map(item =>
                    item.szak_kod === szakfelelos.szak_kod ? { ...item, szakjelentes_created_this_period: true } : item
                ));
            }
            setErrorMessage(err.response?.data?.error || 'Nem sikerült létrehozni az új szakjelentést.');
            console.error('Nem sikerült létrehozni az új szakot:', err);
        } finally {
            setCreatingSzakKod(null);
        }
    };

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="szakjelentes-letrehozas">
            <div className="header">
                <h1>Szakjelentés létrehozása</h1>
            </div>
            {errorMessage && <p role="alert">{errorMessage}</p>}
            <div className="tiles">
                {filteredData.map((item) => {
                    const canCreateAgain = canCreateMultipleReports(userData?.neptun, item.szakfelelos_neptun_kodja);
                    const isDisabled = loading || !activePeriod || Boolean(creatingSzakKod) || (item.szakjelentes_created_this_period && !canCreateAgain);
                    
                    return (
                        <Tile
                            key={item.id}
                            icon={<i className="material-icons">add</i>}
                            text={`${item.kepzes_neve} - ${item.kepzesi_szint}`} 
                            onClick={() => handleTileClick(item)}
                            disabled={isDisabled}
                        />
                    );
                })}
            </div>
        </div>
        </div>
    );
}

export default SzakjelentesLetrehozas;
